export const profileLinks = {
    instagram: (user: string): string => `https://instagram.com/${user}`,
    facebook: (user: string): string => `https://facebook.com/${user}`,
    twitter: (user: string): string => `https://twitter.com/${user}`,
};
